@if (showConsent) {
<div class="cookie-consent" [@inOutAnimation]>
  @if ((isCustomTranslationsEnabled$ | async) !== null) {
  <h3 [ngClass]="activeCountry$ | async">
    {{
      'cookieConsent.title'
        | cxTranslate
          : {
              context: setCustomContext(
                isCustomTranslationsEnabled$ | async,
                activeCountry$ | async,
                activeLanguage$ | async
              )
            }
    }}
  </h3>
  }
  <p [innerHTML]="content$ | async"></p>
  @if ((isCustomTranslationsEnabled$ | async) !== null) {
  <button class="primary-btn" (click)="onCookieAccepted()" [ngClass]="activeCountry$ | async">
    {{
      'cookieConsent.continue'
        | cxTranslate
          : {
              context: setCustomContext(
                isCustomTranslationsEnabled$ | async,
                activeCountry$ | async,
                activeLanguage$ | async
              )
            }
    }}
  </button>
  }
</div>
}
